export default __webpack_public_path__ + "static/media/Sport.93066248.svg";